// components
import AppListItem from "../AppListItem/AppListItem";
// images
import pricing from "../../../../assets/images/pricing.png";
import following from "../../../../assets/images/following.png";
import stats from "../../../../assets/images/stats.png";
import googlePlay from "../../../../assets/images/googlePlay.png";
import appStore from "../../../../assets/images/appStore.png";

const SupplierApp = () => (
  <div className="mt-7 ml-auto md:ml-16 mr-auto md:mr-0 w-4/5 md:w-auto rounded-lg border-2 border-light-gray flex flex-col grow justify-between relative">
    <div className="absolute -right-0.5 top-5 bg-dark-blue w-2.5 h-20" />
    <div className="mt-5 mr-6 text-right">
      <header>
        <h3 className="text-4xl">تطبيق الموردين</h3>
        <p className="text-dark-gray text-xl font-semibold mt-2">
          يستطيع الموردين من خلال التطبيق
        </p>
      </header>

      <ul className="mt-10 flex flex-col gap-y-8">
        <AppListItem
          imageSource={pricing}
          content="تسعير المنتجات المطلوبه و التحكم في مبيعاتك"
        />
        <AppListItem
          imageSource={following}
          content="متابعه دائمه لحالة طلباتك"
        />
        <AppListItem
          imageSource={stats}
          content="إحصائيات خاصه بمبيعاتك شهر بشهر"
        />
      </ul>
    </div>

    <div className="mt-6 bg-light-gray">
      <div className="w-fit m-auto my-11 flex flex-col gap-4 items-center">
        <p className="text-2xl text-center font-bold">
          حمل تطبيق موتور للموردين
        </p>
        <div className="flex flex-wrap justify-center gap-4">
          <a
            href="https://play.google.com/store/apps/details?id=mtor.mtor_supplierapp"
            target="_blank"
            rel="noreferrer"
            className="w-3/5 md:w-auto"
          >
            <img
              src={googlePlay}
              alt="google play download"
              className="w-full"
            />
          </a>
          <a
            href="/"
            target="_blank"
            rel="noreferrer"
            className="w-3/5 md:w-auto"
          >
            <img src={appStore} alt="app store download" className="w-full" />
          </a>
        </div>
      </div>
    </div>
  </div>
);

export default SupplierApp;
